import {
  URL_SEARCH,
  searchNamesSpeaciality,
  SortKey,
  sortNames,
} from 'constants/search-data/big-search-page-data'
import { ISpecialities } from 'store/lists/useSpecialities'
import { SEOType } from 'constants/SEO'
import { MainPageBC, TBreadCrumbs } from 'constants/SEO-breadcrumbs'

const CARDS_ON_PAGE = 5
const PAGE_LIMIT = 2

const getURL = (searchString: string, key: string, offset: string, selectedSort: string[]) => {
  return `${URL_SEARCH}/?s=${searchString}&type=${key}&offset=${offset}&sort=${selectedSort[0]}`
}

const getPageSEO = (searchString: string, path: string, page: number) => {
  const pageString = page >= PAGE_LIMIT ? ` - Страница ${page}` : ''
  const SpecialityPageSEO = {
    [SEOType.TITLE]: `Обучение для врачей по специальности «${searchString}» ${pageString}`,
    [SEOType.DESCRIPTION]: `Программы НМО по специализации «${searchString}»: вебинары, курсы НМО, записи лекций, результаты исследований и клинические рекомендации в одном месте! Пройти обучение можно в очном и дистанционном формате, получайте баллы НМО онлайн через личный кабинет ${pageString}`,
    [SEOType.LINK]: `${URL}${path}`,
  }
  return SpecialityPageSEO
}

const getPageBC = (searchString: string) => {
  const SpecialityPageBC: TBreadCrumbs = [
    ...MainPageBC,
    {
      id: `${URL}/speciality?s=${searchString}`,
      name: `Обучение для врачей по специальности «${searchString}»`,
    },
  ]
  return SpecialityPageBC
}

const normalizeData = (
  path: string,
  query: Record<string, string | string[] | undefined>,
  specialities: ISpecialities[],
  typeSearchNames: number
) => {
  const idFromUrl = path.match(/(\d+)/)
  const idSpeciality = idFromUrl ? Number(idFromUrl[0]) : null

  const foundSpeciality = specialities.find((speciality) => speciality.value === idSpeciality)

  const type = searchNamesSpeaciality[typeSearchNames]
  const sort = sortNames[1]
  const searchString = (query.s as string) || foundSpeciality?.label || 'Диетология'
  const selectedSort = SortKey[sort as string]
  const pageId = query.id

  return { type, sort, searchString, selectedSort, pageId }
}

export { getURL, getPageSEO, getPageBC, normalizeData, CARDS_ON_PAGE }
